import { SET_PRODUCTS } from 'actions/types'
import api, { urls } from 'config/api'

export const _setProducts = (products) => ({
  type: SET_PRODUCTS,
  products,
})

export const getProducts = (fundraiserId) => async (dispatch) => {
  const {
    data: { results: products },
  } = await api.get(urls.fundraiserProducts({ fundraiserId }))
  await dispatch(_setProducts(products))
  return products
}
